import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lista" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "flex justify-content-end" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DataTable, {
        filters: _ctx.filters,
        value: _ctx.list,
        showGridlines: "",
        globalFilterFields: ['data']
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_InputText, {
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                placeholder: "Pesquisar data"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode(" Nenhuma data encontrada. ")
        ]),
        loading: _withCtx(() => [
          _createTextVNode(" Carregando dados. Por favor, aguarde. ")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "data",
            header: "Data da visita"
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.data), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "total",
            header: "Quantidade de pessoas"
          }),
          _createVNode(_component_Column, {
            field: "status",
            header: "Status"
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(_ctx.textoStatus[data.status]), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["filters", "value"])
    ])
  ]))
}